module.exports = __webpack_public_path__ + "assets/img/28@3x.b37d48cf.png";